import { useEffect, useState } from 'react';
import { getCountries } from '../controller/ecobalyseController';
import { getCountryFromCode } from '../utils/utils';
import ReliabilityDetailsModel from '../model/ReliabilityDetailsModel';

import countriesPrepositions from '../utils/countries.json';

type CountriesPrepositions = { [key: string]: string };

const typedCountriesPrepositions =
  countriesPrepositions as CountriesPrepositions;

interface CountriesProps {
  country_fabric: string;
  country_dyeing: string;
  country_making: string;
  reliability_details: ReliabilityDetailsModel;
}

export default function Countries(props: CountriesProps) {
  const [fullCountries, setFullCountries] = useState<any[]>([]);

  const getPreposition = (country: string): string => {
    return (countriesPrepositions as CountriesPrepositions)[country] || 'en';
  };

  useEffect(() => {
    getCountries().then((countries) => {
      setFullCountries(countries);
    });
  }, []);

  return (
    <div className="bg-blackOverlay dark:bg-whiteOverlay md:rounded-3xl rounded-2xl md:p-6 p-4 group flex flex-col gap-3 md:text-xl xshort:text-sm text-sm font-medium">
      <div className="flex flex-wrap justify-around items-center">
        <div className="flex gap-2 items-center">
          <svg
            fill="currentColor"
            className="w-5"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M22,1H18a1,1,0,0,0-1,1V9H15V7a1,1,0,0,0-1.447-.895L9,8.382V7a1,1,0,0,0-1.447-.895l-6,3A1,1,0,0,0,1,10V22a1,1,0,0,0,1,1H22a1,1,0,0,0,1-1V2A1,1,0,0,0,22,1ZM21,3V5H19V3ZM3,21V10.618l4-2V10a1,1,0,0,0,1.447.895L13,8.618V10a1,1,0,0,0,1,1h4a1,1,0,0,0,1-1V7h2V21Zm2-8H8v2H5Zm5,0h4v2H10Zm6,0h3v2H16ZM5,17H8v2H5Zm5,0h4v2H10Zm6,0h3v2H16Z" />
          </svg>
          <p>
            {fullCountries.length > 0
              ? props.reliability_details.unknown_country_fabric
                ? '?'
                : getCountryFromCode(props.country_fabric, fullCountries)
              : ''}
          </p>
        </div>

        <svg
          className="w-7"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M6 12H18M18 12L13 7M18 12L13 17"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>

        <div className="flex gap-2 items-center">
          <svg
            className="w-5"
            fill="currentColor"
            viewBox="0 0 48 48"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g id="Layer_2" data-name="Layer 2">
              <g id="invisible_box" data-name="invisible box">
                <rect width="48" height="48" fill="none" />
              </g>
              <g id="Layer_6" data-name="Layer 6">
                <g>
                  <path d="M16.5,2.6A1.8,1.8,0,0,0,15.1,2a2,2,0,0,0-1.4.6,1.9,1.9,0,0,0,0,2.8L19.4,11,6.2,24.1a3.9,3.9,0,0,0,0,5.6L19.4,42.8A3.8,3.8,0,0,0,22.2,44,3.9,3.9,0,0,0,25,42.8L41,26.9ZM9.1,26.9l13.1-13,13,13Z" />
                  <path d="M41,32s-4,5.8-4,8a4,4,0,0,0,8,0C45,37.8,41,32,41,32Z" />
                </g>
              </g>
            </g>
          </svg>
          <p>
            {fullCountries.length > 0
              ? props.reliability_details.unknown_country_dyeing
                ? '?'
                : getCountryFromCode(props.country_dyeing, fullCountries)
              : ''}
          </p>
        </div>

        <svg
          className="w-7"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M6 12H18M18 12L13 7M18 12L13 17"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>

        <div className="flex gap-2 items-center">
          <svg
            fill="currentColor"
            className="w-5"
            viewBox="0 0 32 32"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M23.994 18.252h-2.711c-0.014-0.001-0.025-0.008-0.039-0.008-0.414 0-0.75 0.336-0.75 0.75v0c0 0.002 0 0.004 0 0.006 0 1.104-0.895 2-2 2s-2-0.895-2-2c0-0.002 0-0.004 0-0.007v0c-0-0.414-0.336-0.75-0.75-0.75v0c-0.014 0-0.025 0.007-0.039 0.008h-1.957v-1.33c1.584-0.354 2.75-1.748 2.75-3.415s-1.166-3.060-2.727-3.41l-0.023-0.004v-2.095c-0-0.414-0.336-0.75-0.75-0.75h-10.999c-0.414 0-0.75 0.336-0.75 0.75v0 10.976l-0.005 0.024v11c0 0.414 0.336 0.75 0.75 0.75l21.999 0.004c0.414-0 0.75-0.336 0.75-0.75v0-11c-0-0.414-0.336-0.75-0.75-0.75v0zM2.75 8.748h9.499v2.010c0 0.414 0.336 0.75 0.75 0.75v0c1.105 0 2 0.895 2 2s-0.895 2-2 2v0c-0.414 0-0.75 0.336-0.75 0.75v0 1.99h-1.331c-0.351-1.588-1.746-2.758-3.415-2.758s-3.064 1.17-3.411 2.734l-0.004 0.023h-1.338zM2.745 19.748h1.957c0.017 0.001 0.031 0.010 0.048 0.010 0.416-0.006 0.751-0.343 0.754-0.759v-0c0.003-1.101 0.896-1.993 1.998-1.993 1.103 0 1.998 0.894 1.998 1.998 0 0.002 0 0.003 0 0.005v-0c0 0.414 0.336 0.75 0.75 0.75v0c0.017 0 0.031-0.009 0.048-0.010h1.948v1.332c-1.584 0.355-2.75 1.75-2.75 3.416 0 1.442 0.873 2.681 2.12 3.215l0.023 0.009c0.171 0.074 0.374 0.139 0.584 0.186l0.023 0.004v1.338h-9.5zM23.244 29.252h-9.499v-1.96c0.001-0.015 0.009-0.028 0.009-0.043-0.006-0.416-0.343-0.751-0.758-0.754h-0c-1.102-0.003-1.994-0.896-1.994-1.998 0-1.104 0.895-1.998 1.998-1.998 0.002 0 0.003 0 0.005 0h-0c0.414-0 0.75-0.336 0.75-0.75v0c0-0.015-0.008-0.028-0.009-0.043v-1.953h1.338c0.357 1.58 1.749 2.742 3.412 2.742s3.055-1.162 3.407-2.719l0.004-0.023h1.338zM29.994 1.25h-10.998c-0.414 0-0.75 0.336-0.75 0.75v0 2.702c-0.001 0.017-0.010 0.031-0.010 0.048 0 0.414 0.336 0.75 0.75 0.75v0c1.105 0 2 0.895 2 2s-0.895 2-2 2v0c-0.414 0-0.75 0.336-0.75 0.75v0c0 0.017 0.009 0.031 0.010 0.048v2.702c0 0.414 0.336 0.75 0.75 0.75h2.076c0.354 1.584 1.748 2.75 3.415 2.75s3.060-1.166 3.41-2.727l0.004-0.023h2.093c0.414-0 0.75-0.336 0.75-0.75v0-11c-0-0.414-0.336-0.75-0.75-0.75h-0zM29.244 12.25h-2.008c-0.414 0-0.75 0.336-0.75 0.75v0c0 1.105-0.895 2-2 2s-2-0.895-2-2v0c-0-0.414-0.336-0.75-0.75-0.75h-1.99v-1.338c1.579-0.358 2.74-1.749 2.74-3.412s-1.161-3.054-2.717-3.407l-0.023-0.004v-1.338h9.498z"></path>
          </svg>
          <p>
            {fullCountries.length > 0
              ? props.reliability_details.unknown_country_making
                ? '?'
                : getCountryFromCode(props.country_making, fullCountries)
              : ''}
          </p>
        </div>

        <svg
          className="w-7"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M6 12H18M18 12L13 7M18 12L13 17"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>

        <div className="flex gap-2 items-center">
          <svg
            className="w-5"
            viewBox="0 0 24 24"
            id="Layer_1"
            data-name="Layer 1"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              className="fill-none stroke-1 stroke-black dark:stroke-white"
              d="M17.25,1.5H3.6L1.5,6.75A2.52,2.52,0,0,0,4.12,9.14,2.52,2.52,0,0,0,6.75,6.75,2.52,2.52,0,0,0,9.38,9.14,2.52,2.52,0,0,0,12,6.75a2.52,2.52,0,0,0,2.62,2.39,2.52,2.52,0,0,0,2.63-2.39,2.52,2.52,0,0,0,2.63,2.39A2.52,2.52,0,0,0,22.5,6.75L20.4,1.5Z"
            />
            <polyline
              className="fill-none stroke-1  stroke-black dark:stroke-white"
              points="6.75 7.23 6.9 6.43 7.8 1.5"
            />
            <line
              className="fill-none stroke-1  stroke-black dark:stroke-white"
              x1="17.25"
              y1="7.23"
              x2="16.2"
              y2="1.5"
            />
            <line
              className="fill-none stroke-1 stroke-black dark:stroke-white"
              x1="12"
              y1="1.5"
              x2="12"
              y2="7.23"
            />
            <polyline
              className="fill-none stroke-1 stroke-black dark:stroke-white"
              points="20.59 9.14 20.59 22.5 3.41 22.5 3.41 9.14"
            />
            <line
              className="fill-none stroke-1 stroke-black dark:stroke-white"
              x1="0.55"
              y1="22.5"
              x2="23.45"
              y2="22.5"
            />
            <rect
              className="fill-none stroke-1 stroke-black dark:stroke-white"
              x="8.18"
              y="13.91"
              width="7.64"
              height="8.59"
            />
            <line
              className="fill-none stroke-1 stroke-black dark:stroke-white"
              x1="3.41"
              y1="17.73"
              x2="8.18"
              y2="17.73"
            />
            <line
              className="fill-none stroke-1 stroke-black dark:stroke-white"
              x1="15.82"
              y1="17.73"
              x2="20.59"
              y2="17.73"
            />
          </svg>
          <p>France</p>
        </div>
      </div>
      <div className="box-border md:text-base text-sm xshort:text-sm max-h-0 overflow-hidden group-hover:max-h-64 transition-all duration-500 ease-in-out">
        <p className="font-normal mt-3">
          Le tissu composant cet article a été produit{' '}
          {fullCountries.length > 0 ? (
            props.reliability_details.unknown_country_fabric ? (
              <span>
                dans un <span className="italic">pays non partagé</span>
              </span>
            ) : (
              `${getPreposition(
                getCountryFromCode(props.country_fabric, fullCountries),
              )} ${getCountryFromCode(props.country_fabric, fullCountries)}`
            )
          ) : (
            ''
          )}
          , il a ensuite été teint{' '}
          {fullCountries.length > 0 ? (
            props.reliability_details.unknown_country_dyeing ? (
              <span>
                dans un <span className="italic">pays non partagé</span>
              </span>
            ) : (
              `${getPreposition(
                getCountryFromCode(props.country_dyeing, fullCountries),
              )} ${getCountryFromCode(props.country_dyeing, fullCountries)}`
            )
          ) : (
            ' '
          )}{' '}
          puis assemblé{' '}
          {fullCountries.length > 0 ? (
            props.reliability_details.unknown_country_making ? (
              <span>
                dans un <span className="italic">pays non partagé</span>
              </span>
            ) : (
              `${getPreposition(
                getCountryFromCode(props.country_making, fullCountries),
              )} ${getCountryFromCode(props.country_making, fullCountries)}`
            )
          ) : (
            ''
          )}
          .
        </p>
      </div>
    </div>
  );
}
